type KycData = {
  photo: string;
  documentID: string;
  documentType: string;
  expirationDate: string;
  agentId: string;
  agentIdNumber: string;
  address: string;
  firstname: string;
  lastname: string;
  gender: string;
  dateOfBirth: string;
};

// const PersonalFormInput = () => {
//   return (
//     <div>PersonalFormInput</div>
//   )
// }
// export default PersonalFormInput

export const PersonalFormInput = ({
  handleKycOnChange,
  kycData,
  loading,
  handleKycSubmit,
  kyc,
  profilePicUrl,
  user,
  handleChange,
}: {
  user?: any;
  handleKycOnChange: (e: any) => void;
  kycData: KycData;
  loading: boolean;
  handleKycSubmit: any;
  kyc: any;
  profilePicUrl: any;
  handleChange: any;
}) => {
  // Check if all required fields are filled
  const isFormValid = () => {
    return (
      kycData.firstname.trim() !== "" &&
      kycData.lastname.trim() !== "" &&
      kycData.gender.trim() !== "" &&
      kycData.dateOfBirth.trim() !== "" &&
      kycData.documentType.trim() !== "" &&
      kycData.documentID.trim() !== "" &&
      (profilePicUrl || (user?.photo && user?.photo !== "default.jpg"))
    );
  };
  return (
    <div className="mb-4">
      <div className="row">
        <div className="col-md-6 col-12 mb-4">
          <label className="fw-bolder form-label text-capitalize">
            First Name
          </label>
          <input
            type="text"
            className="form-control rounded-pill py-3 px-4 fs-14 mb-3"
            value={kycData.firstname}
            onChange={handleKycOnChange}
            required
            name="firstname"
            placeholder="Enter your first name as shown on your ID"
          />
        </div>
        <div className="col-md-6 col-12 mb-4">
          <label className="fw-bolder form-label text-capitalize">
            Last Name
          </label>
          <input
            type="text"
            className="form-control rounded-pill py-3 px-4 fs-14 mb-3"
            value={kycData.lastname}
            onChange={handleKycOnChange}
            required
            name="lastname"
            placeholder="Enter your last name as shown on your ID"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 col-12 mb-4">
          <label className="fw-bolder form-label text-capitalize">Gender</label>
          <select
            className="form-select rounded-pill py-3 px-4 fs-14 mb-3"
            value={kycData.gender}
            onChange={handleKycOnChange}
            required
            name="gender"
          >
            <option value="">Select</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className="col-md-6 col-12 mb-4">
          <label className="fw-bolder form-label text-capitalize">
            Date of Birth
          </label>
          <input
            type="date"
            className="form-control rounded-pill py-3 px-4 fs-14 mb-3"
            value={kycData.dateOfBirth}
            onChange={handleKycOnChange}
            required
            name="dateOfBirth"
            max={new Date().toISOString().split("T")[0]}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 col-12 mb-4">
          <label className="fw-bolder form-label text-capitalize">
            Document Type
          </label>
          <select
            className="form-select rounded-pill py-3 px-4 fs-14 mb-3"
            value={kycData.documentType}
            onChange={handleKycOnChange}
            required
            name="documentType"
          >
            <option value="">Select</option>
            <option value="NATIONAL_ID">National ID</option>
            {/* <option value="PASSPORT">International Passport</option> */}
            <option value="VOTERS_CARD">Voters Card</option>
            {/* <option value="DRIVERS_LICENCE">Drivers license</option> */}
          </select>
        </div>
        <div className="col-md-6 col-12 mb-4">
          <label className="fw-bolder form-label text-capitalize">
            Document ID
          </label>
          <input
            type="text"
            className="form-control rounded-pill py-3 px-4 fs-14 mb-3"
            value={kycData.documentID}
            onChange={handleKycOnChange}
            required
            name="documentID"
            placeholder="Input ID Number"
          />
        </div>
      </div>

      {/* <div className="row">
        <div className="col-md-6 col-12 mb-2">
          <label className="fw-bolder form-label text-capitalize">
            Expiry Date
          </label>
          <div className="input-group mb-3">
            <input
              type="date"
              className="form-control border-end-0 border-rounded-5 py-3 px-4 rounded-pill-start"
              value={kycData.expirationDate}
              onChange={handleKycOnChange}
              name="expirationDate"
              required
              id="expiryDate"
              min={
                new Date(new Date().getTime() + 86400000)
                  .toISOString()
                  .split("T")[0]
              }
            />
            <label
              className="input-group-text rounded-pill-end bg-transparent text-link text-decoration-none border-start-0 pe-4"
              htmlFor="expiryDate"
            >
              ID Expiry Date
            </label>
          </div>
        </div>
        <div className="col-md-6 col-12 mb-4">
          <label className="fw-bolder form-label text-capitalize">
            Location
          </label>
          {isLoaded ? (
            <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
              <input
                type="text"
                className="form-control rounded-pill py-3 px-4 fs-14 mb-3"
                value={kycData.address}
                onChange={handleKycOnChange}
                required
                name="address"
                placeholder="Input your address"
              />
            </Autocomplete>
          ) : (
            <input
              type="text"
              className="form-control rounded-pill py-3 px-4 fs-14 mb-3"
              value={kycData.address}
              onChange={handleKycOnChange}
              required
              name="address"
              placeholder="Input your address"
            />
          )}
        </div>
      </div> */}
      <div className="col-md-6 col-12 mb-4">
        {kyc?.status === "APPROVED" || kyc?.status === "PENDING" ? (
          ""
        ) : (
          <div className="row mb-3">
            <div className="col-12 col-md-5 mb-5 mb-md-0">
              <label className="fw-bolder form-label text-capitalize">
                Passport Photograph
              </label>
              <div
                className="align-self-center text-center position-relative "
                style={{ width: "max-content" }}
              >
                {profilePicUrl ? (
                  <>
                    <img
                      src={profilePicUrl}
                      alt="Passport Photograph"
                      style={{ objectFit: "cover" }}
                      height={100}
                      width={100}
                      className="rounded-circle "
                    />
                    <input
                      type="file"
                      id="upload-circle"
                      hidden
                      name="profilePic"
                      onChange={handleChange}
                    />
                    <label
                      htmlFor="upload-circle"
                      className="me-auto rounded-circle d-flex align-items-center justify-content-center mb-2 bg-dark opacity-75 position-absolute top-50 start-50 translate-middle cursor-pointer"
                      style={{ height: 100, width: 100 }}
                    >
                      <i className="fa-light fa-camera fs-22 text-white"></i>
                    </label>
                  </>
                ) : (
                  <>
                    <button
                      type="button"
                      className="btn border-primary text-primary rounded-pill py-3 px-4 fw-bold fs-14"
                      onClick={() =>
                        document.getElementById("upload-circle")?.click()
                      }
                    >
                      <i className="fa-solid fa-upload text-primary me-2"></i>
                      Upload ID
                    </button>
                    <input
                      type="file"
                      id="upload-circle"
                      hidden
                      name="profilePic"
                      onChange={handleChange}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="mb-2">
        <button
          type="button"
          className="btn btn-primary rounded-pill py-3 px-5 fw-bold fs-14 col-12 col-md-4 mb-3"
          disabled={loading || !isFormValid()}
          onClick={handleKycSubmit}
        >
          {loading ? (
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          ) : (
            "Submit Personal KYC"
          )}
        </button>
      </div>
    </div>
  );
};
